import { Link } from "react-router-dom";
import { format } from "date-fns";

export const BlogCard = ({ post, featured = false }) => {
  const formattedDate = format(new Date(post.published_at), "MMMM d, yyyy");

  if (featured) {
    return (
      <Link
        to={`/blog/${post.slug}`}
        data-testid={`blog-card-${post.slug}`}
        className="blog-card block group"
      >
        <div className="relative aspect-video md:aspect-[21/9] overflow-hidden mb-6">
          <img
            src={post.image_url}
            alt={post.title}
            className="blog-card-image w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
          <div className="absolute bottom-6 left-6 right-6">
            <p className="font-accent text-xs text-white/80 uppercase tracking-widest mb-2">
              {formattedDate}
            </p>
            <h2 className="font-serif text-2xl md:text-4xl font-semibold text-white">
              {post.title}
            </h2>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/blog/${post.slug}`}
      data-testid={`blog-card-${post.slug}`}
      className="blog-card block group"
    >
      <div className="relative aspect-video overflow-hidden mb-4">
        <img
          src={post.image_url}
          alt={post.title}
          className="blog-card-image w-full h-full object-cover"
        />
      </div>
      <p className="font-accent text-xs text-stone-500 uppercase tracking-widest mb-2">
        {formattedDate}
      </p>
      <h3 className="font-serif text-xl font-medium text-stone-900 group-hover:text-deep-moss transition-colors mb-2">
        {post.title}
      </h3>
      <p className="font-sans text-sm text-stone-600 line-clamp-2">
        {post.excerpt}
      </p>
    </Link>
  );
};
